// extracted by css-extract-rspack-plugin
export default {"cls1":"Playlist-cls1_zzT","cls2":"Playlist-cls2_oxS Playlist-cls1_zzT"};